import { addURLSearchParams, readURLSearchParams } from 'helpers/common';
import * as c from 'models/constants';
import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IOfficesData } from 'models/shop/office';
import { getShopTypeDomainValues } from 'redux/modules/domainvalues';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IAuthContext } from 'models/common';
import SearchFilter from '../SalonsPage/FilterFields/SearchFilter';
import LocationFilter from '../SalonsPage/FilterFields/LocationFilter';
import LandingPageJoinPopup from '../LandingPageJoinPopup';
import { AvatarSmall, Button } from 'components';
import { browserHistory, withRouter } from 'react-router';
import { cookies } from 'helpers/cookies';
import renderIcon from 'helpers/renderIcon';
import Slider from 'react-slick';
import { ContactUsForm } from 'containers/Shop/CreateShop/CreateShopPresentation/ContactUsForm';
import { IStore } from 'redux/IStore';
import { IUserProfileData } from 'models/user/userprofile';
import { getHomePageStatistics } from 'redux/modules/landingpagedata';
import { ILandingPageData } from 'models/landingpagedata';
require('./style.scss');

interface IProps {
	t?: (key: string) => string;
	// redux state
	shopTypeDomainValues: any;
	officesData: IOfficesData;
	userprofile: IUserProfileData;
	landingpagedata: ILandingPageData;

	// redux dispatch
	getShopTypeDomainValues: () => Promise<any>;
	getHomePageStatistics: () => Promise<any>;
	setShopTypeFilter: any;
	context?: IAuthContext;

	// with router
	location: any;
}

interface IState {
	showPopup: boolean;
	salonsBeingScrolled: boolean;
	searchString?: string;
}

const addURLSearchParamsToURLString = (urlString: string, name: string, value: string) => {
	const url = new URL(urlString);

	// Param exists - remove it first
	if (url.searchParams.get(name)) {
		url.searchParams.delete(name);
	}
	// Param doesn't exist
	url.searchParams.append(name, value);

	return url;
};

class LandingPageComponent extends React.Component<IProps, IState> {
	popupTimeout = null;
	observer = null;

	constructor(props) {
		super(props);

		this.render = this.render.bind(this);
		this.scrollToRef = this.scrollToRef.bind(this);
		this.getReviews = this.getReviews.bind(this);
		this.getSalonEndorsements = this.getSalonEndorsements.bind(this);
		this.getSalons = this.getSalons.bind(this);
		this.handleOnRegisterClick = this.handleOnRegisterClick.bind(this);
		this.shuffleElements = this.shuffleElements.bind(this);
		this.setPopupObserver = this.setPopupObserver.bind(this);
		this.closePopupHandler = this.closePopupHandler.bind(this);

		this.featuresRef = React.createRef();

		this.state = {
			showPopup: false,
			salonsBeingScrolled: false,
		};
	}

	history = browserHistory;

	featuresRef: React.RefObject<HTMLDivElement>;

	public componentDidMount() {
		const { userprofile } = this.props;
		const hasAcceptedCookies = userprofile?.cookies?.hasAcceptedCookies || false;

		this.props.getShopTypeDomainValues();
		this.props.getHomePageStatistics();

		// get categories from url
		const categories = readURLSearchParams(c.SHOPS_CATEGORIES_FILTER);

		if (categories) {
			this.props.setShopTypeFilter(categories.split(',').map((e) => +e));
		}

		if (hasAcceptedCookies) {
			this.setPopupObserver();
		}
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (prevProps?.userprofile?.cookies?.hasAcceptedCookies !== this?.props?.userprofile?.cookies?.hasAcceptedCookies) {
			this.setPopupObserver();
		}
	}

	componentWillUnmount() {
		if (this.popupTimeout) {
			clearTimeout(this.popupTimeout);
		}

		if (this.observer) {
			this.observer.disconnect();
		}
	}

	private setPopupObserver = () => {
		if (!this.props.context.isAuthenticated()) {
			this.observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) {
							// The element is visible, show the popup after 4 seconds
							const languageCookie = cookies.get(c.COOKIE_KEY_LANDING_PAGE_POPUP);

							if (languageCookie !== 'true') {
								this.popupTimeout = setTimeout(() => {
									this.setState({ showPopup: true });
								}, 4000);
							}

							this.observer.disconnect();
						}
					});
				},
				{ threshold: 0.1 },
			); // threshold represents the percentage of visibility, adjust as needed

			// Use document.querySelector to select the element
			const preloaderElement = document.querySelector('#preloader');

			// Ensure the element exists before observing it
			if (preloaderElement) {
				this.observer.observe(preloaderElement);
			}
		}
	};

	private closePopupHandler = () => {
		this.setState({ showPopup: false });
	};

	scrollToRef = (e, ref) => {
		e.preventDefault();
		ref?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
	};

	private shuffleElements = (array: JSX.Element[]) => {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
		return array;
	};

	getReviews = (t) => {
		const elementsArray: JSX.Element[] = [];

		for (let i = 0; i < 7; i++) {
			try {
				const reviewBodyText: string = t(`CreateShopPresentation_Reviews_Review_${i}_Body`) || '';

				elementsArray.push(
					<div className="landing-page__userReviews__review-container" key={`review-${i}`}>
						<div className="landing-page__userReviews__review">
							{renderIcon('quote', undefined, undefined, 'landing-page__userReviews__review__icon')}
							<div
								className={`landing-page__userReviews__review__body ${reviewBodyText?.length > 350 ? 'shrink' : ''}`}
							>
								{t(`CreateShopPresentation_Reviews_Review_${i}_Body`)}
							</div>
							<div className="landing-page__userReviews__review__person">
								<img
									src={require(`containers/Html/images/ShopPresentation/person_${i}.png`)}
									className="landing-page__userReviews__review__person__image"
									alt={`image of ${t(`CreateShopPresentation_Reviews_Review_${i}_Name`)}`}
									loading="lazy"
								/>
								<div className="landing-page__userReviews__review__person__name-container">
									<div className="landing-page__userReviews__review__person__name-container__name">
										{t(`CreateShopPresentation_Reviews_Review_${i}_Name`)}
									</div>
									<div className="landing-page__userReviews__review__person__name-container__description">
										{t(`CreateShopPresentation_Reviews_Review_${i}_Description`)}
									</div>
								</div>
							</div>
						</div>
					</div>,
				);
			} catch (error) {
				elementsArray.push(
					<div className="landing-page__userReviews__review-container" key={`review-${i}`}>
						<div className="landing-page__userReviews__review">
							{renderIcon('quote', undefined, undefined, 'landing-page__userReviews__review__icon')}
							<div className="landing-page__userReviews__review__body">
								{t(`CreateShopPresentation_Reviews_Review_${i}_Body`)}
							</div>
							<div className="landing-page__userReviews__review__person">
								<div className={`landing-page__userReviews__review__person__name-container customer`}>
									<div className="landing-page__userReviews__review__person__name-container__name">
										{t(`CreateShopPresentation_Reviews_Review_${i}_Name`)}
									</div>
									<div className="landing-page__userReviews__review__person__name-container__description"></div>
								</div>
							</div>
						</div>
					</div>,
				);
			}
		}

		return this.shuffleElements(elementsArray);
	};

	getSalonEndorsements = (t) =>
		new Array(14).fill(0).map((_, i) => {
			return (
				<div className="landing-page__salonsThatTrustUs__salonWrapper" key={`salon-${i}`}>
					<div className="landing-page__salonsThatTrustUs__salon">
						<img
							src={require(`containers/Html/images/landingpage/salon_${i}.png`)}
							className="landing-page__salonsThatTrustUs__salon__image"
							alt={`image of ${t(`LandingPage_SalonsThatTrustUs_Salon_${i}_AltText`)}`}
							loading="lazy"
						/>
					</div>
				</div>
			);
		});

	getSalons = (salonsSet) => {
		if (!salonsSet) {
			return null;
		}

		const { landingpagedata } = this.props;

		return new Array(4).fill(0).map((_, i) => {
			const salonData = landingpagedata?.lastApprovedShops?.[i];

			return (
				<div className="landing-page__newSalons__salonWrapper" key={`salon-${i}`}>
					<div
						className="landing-page__newSalons__salon"
						onClick={() => {
							!this.state.salonsBeingScrolled && salonData?.code && browserHistory.push(`/shop/${salonData.code}`);
						}}
					>
						<div className="landing-page__newSalons__salon__contentContainer">
							<div className="landing-page__newSalons__salon__imageContainer">
								{salonData?.picture ? (
									<AvatarSmall imageUrl={salonData?.picture} fromShop={true} />
								) : (
									renderIcon('pfp_salon')
								)}{' '}
							</div>
							<div className="landing-page__newSalons__salon__infoContainer">
								<span className="landing-page__newSalons__salon__name">{salonData?.name}</span>
								<span className="landing-page__newSalons__salon__location">{salonData?.location}</span>
							</div>
						</div>
					</div>
				</div>
			);
		});
	};

	private handleOnRegisterClick(e, signinRedirectJoin) {
		e.preventDefault();
		signinRedirectJoin();
	}

	public render() {
		const { t, landingpagedata } = this.props;
		const { signinRedirectJoin, isAuthenticated } = this.props.context;
		const salonsSet: boolean = landingpagedata?.lastApprovedShops?.length ? true : false;

		const forUsersButton: JSX.Element = (
			<button
				className="btnPrimary bsPortalBtn bsPortalBtnLarge landing-page__forUsers__leftContainer__button"
				onClick={() => {
					this.history.push('/salons');
				}}
			>
				{t('LandingPage_ForUsers_ButtonText')}
			</button>
		);

		const forBusinessButton: JSX.Element = isAuthenticated() ? (
			<button
				className="btnPrimary bsPortalBtn bsPortalBtnLarge landing-page__forBusiness__rightContainer__button"
				onClick={() => {
					this.history.push('/salon/create');
				}}
			>
				{t('LandingPage_ForBusiness_ButtonText')}
			</button>
		) : (
			<button
				className="btnPrimary bsPortalBtn bsPortalBtnLarge landing-page__forBusiness__rightContainer__button"
				onClick={(e) => {
					this.handleOnRegisterClick(e, signinRedirectJoin);
				}}
			>
				{t('LandingPage_ForBusiness_ButtonText')}
			</button>
		);

		return (
			<div className="landing-page-container">
				{this.state.showPopup && <LandingPageJoinPopup closePopup={this.closePopupHandler} />}
				<div className="landing-page-video-wrapper">
					<iframe
						src="https://player.vimeo.com/video/735717302?h=6a0e217f8a&background=1"
						frameBorder="0"
						allow="autoplay"
						title="Glossiq BG 1"
					></iframe>
					<div className="centered-main-wrapper">
						<h1 className="heading-text">
							<i>{t('LandingPage_Heading_italic')}</i> {t('LandingPage_Heading_normal_1')}{' '}
							<u>{t('LandingPage_Heading_underlined')}</u> {t('LandingPage_Heading_normal_2')}
							<br className="heading-text-break" /> <b>{t('LandingPage_Heading_bold')}</b>
							{t('LandingPage_Heading_normal')}
							<b> {t('LandingPage_Heading_bold_2')}</b>
						</h1>
						<p className="landing-page-subtext">{t('LandingPage_Subtext')}</p>
						<div className="search">
							<div className="search-filters">
								<SearchFilter
									inputChanged={(value) => {
										this.setState({ searchString: value });
									}}
									customIcon="landing_page_search"
									customIconWidth={16}
									customIconHeight={16}
									isLandingPage={true}
								/>
								<LocationFilter
									customIcon="landing_page_location"
									customIconWidth={16}
									customIconHeight={16}
									isLandingPage={true}
								/>
							</div>

							<Button
								onClick={() => {
									// Does not update fast enough for redirect but
									// persists when back button is clicked
									if (this.state.searchString)
										addURLSearchParams(c.SHOPS_SEARCH_FILTER, this.state.searchString, this.history);

									// Manually add search to url because of debounce
									const redirectToSearch = this.state.searchString
										? addURLSearchParamsToURLString(
												window.location?.href,
												c.SHOPS_SEARCH_FILTER,
												this.state.searchString,
										  )?.search
										: window.location?.search;
									this.history.push(redirectToSearch ? `/salons${redirectToSearch}` : `/salons`);
								}}
								className="landing-page-video-wrapper__searchButton"
							>
								{t('SearchShops_Title2')}
							</Button>
						</div>
						<div className="landing-page-video-wrapper__toBottomButton">
							{renderIcon('landing_page_down', 40, 40, 'landing-page-video-wrapper__toBottomButton__icon', (e) => {
								this.scrollToRef(e, this.featuresRef);
							})}
						</div>
					</div>
				</div>

				<div className="landing-page-features">
					<div className="landing-page__newSalons__wrapper">
						<div className={`landing-page-features-ref ${salonsSet ? '' : 'no-salons'}`} ref={this.featuresRef}></div>
						<div className="container">
							<div className="row">
								<div className="col-12">
									{salonsSet && <h3 className="landing-page__newSalons__title">{t('LandingPage_NewSalons_Title')}</h3>}
									<Slider
										{...{
											dots: true,
											infinite: false,
											speed: 500,
											slidesToShow: 4,
											slidesToScroll: 1,
											showArrows: false,
											lazyLoad: true,
											onSwipe: () => {
												this.setState({ salonsBeingScrolled: true });
											},
											afterChange: () => {
												this.setState({ salonsBeingScrolled: false });
											},
											responsive: [
												{
													breakpoint: 1200,
													settings: {
														slidesToShow: 2,
													},
												},
												{
													breakpoint: 800,
													settings: {
														slidesToShow: 1,
													},
												},
											],
										}}
									>
										{this.getSalons(salonsSet)}
									</Slider>
								</div>
							</div>
						</div>
					</div>

					<div className="landing-page__statistics__wrapper">
						<div className="container">
							<div className="row justify-content-center">
								<div className="col-12">
									<div className="landing-page__statistics__container">
										<h2 className="landing-page__statistics__title">
											<span className="landing-page__statistics__title__1">{t('LandingPage_Statistics_Title_1')}</span>{' '}
											<span className="landing-page__statistics__title__2">{t('LandingPage_Statistics_Title_2')}</span>{' '}
											<span className="landing-page__statistics__title__3">{t('LandingPage_Statistics_Title_3')}</span>
										</h2>
										<p className="landing-page__statistics__text">{t('LandingPage_Statistics_Text')}</p>
										{landingpagedata?.totalAppointments &&
										landingpagedata?.totalApprovedShops &&
										landingpagedata?.totalApprovedArticles ? (
											<div className="landing-page__statistics__statistic__wrapper">
												<div className="landing-page__statistics__statistic">
													<span className="landing-page__statistics__statistic__number">
														{landingpagedata?.totalAppointments}
													</span>
													<span className="landing-page__statistics__statistic__subtext">
														{t('LandingPage_Statistics_Subtext_1')}
													</span>
												</div>

												<div className="landing-page__statistics__statistic">
													<span className="landing-page__statistics__statistic__number">
														{landingpagedata?.totalApprovedShops}
													</span>
													<span className="landing-page__statistics__statistic__subtext">
														{t('LandingPage_Statistics_Subtext_2')}
													</span>
												</div>

												<div className="landing-page__statistics__statistic">
													<span className="landing-page__statistics__statistic__number">
														{landingpagedata?.totalApprovedArticles}
													</span>
													<span className="landing-page__statistics__statistic__subtext">
														{t('LandingPage_Statistics_Subtext_3')}
													</span>
												</div>
											</div>
										) : null}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="landing-page__forUsers__wrapper">
						<div className="container">
							<div className="row align-items-md-center flex-md-row flex-column-reverse">
								<div className="col-md-6 col-12 d-md-flex justify-content-md-end">
									<div className="landing-page__forUsers__leftContainer">
										<span className="landing-page__forUsers__leftContainer__upperText">
											{t('LandingPage_ForUsers_UpperText')}
										</span>
										<h3 className="landing-page__forUsers__leftContainer__title">{t('LandingPage_ForUsers_Title')}</h3>
										<p className="landing-page__forUsers__leftContainer__text">{t('LandingPage_ForUsers_Text')}</p>
										{forUsersButton}
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="landing-page__forUsers__rightContainer">
										<img
											src={require(`containers/Html/images/landingpage/for_users.png`)}
											className="landing-page__forUsers__rightContainer__image"
											alt={t('LandingPage_ForUsers_UpperText')}
											loading="lazy"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="landing-page__forBusiness__wrapper">
						<div className="container">
							<div className="row align-items-md-center flex-md-row flex-column">
								<div className="col-md-6 col-12">
									<div className="landing-page__forBusiness__leftContainer">
										<img
											src={require(`containers/Html/images/landingpage/for_business.png`)}
											className="landing-page__forBusiness__leftContainer__image"
											alt={t('LandingPage_ForBusiness_UpperText')}
											loading="lazy"
										/>
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="landing-page__forBusiness__rightContainer">
										<span className="landing-page__forBusiness__rightContainer__upperText">
											{t('LandingPage_ForBusiness_UpperText')}
										</span>
										<h3 className="landing-page__forBusiness__rightContainer__title">
											{t('LandingPage_ForBusiness_Title')}
										</h3>
										<p className="landing-page__forBusiness__rightContainer__text1">
											{t('LandingPage_ForBusiness_Text1')}
										</p>
										<p className="landing-page__forBusiness__rightContainer__text2">
											{t('LandingPage_ForBusiness_Text2')}
										</p>
										{forBusinessButton}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="landing-page__salonsThatTrustUs__wrapper">
						<div className="container">
							<div className="row">
								<div className="col-12">
									<h3 className="landing-page__salonsThatTrustUs__title">{t('LandingPage_SalonsThatTrustUs_Title')}</h3>
								</div>
							</div>
						</div>
						<Slider
							{...{
								dots: false,
								infinite: true,
								autoplay: true,
								autoplaySpeed: 3000,
								speed: 500,
								slidesToShow: 6,
								swipeToSlide: true,
								showArrows: false,
								lazyLoad: true,
								responsive: [
									{
										breakpoint: 1200,
										settings: {
											slidesToShow: 4,
										},
									},
									{
										breakpoint: 800,
										settings: {
											slidesToShow: 3,
										},
									},
								],
							}}
						>
							{this.getSalonEndorsements(t)}
						</Slider>
					</div>

					<div className="landing-page__userReviews__wrapper">
						<div className="container">
							<div className="row">
								<div className="col-12">
									<h2 className="landing-page__userReviews__title">{t('CreateShopPresentation_Reviews_Title')}</h2>
								</div>
							</div>
						</div>

						<Slider
							{...{
								dots: true,
								infinite: false,
								speed: 500,
								slidesToShow: 3,
								slidesToScroll: 1,
								showArrows: false,
								lazyLoad: true,
								responsive: [
									{
										breakpoint: 1700,
										settings: {
											slidesToShow: 2,
										},
									},
									{
										breakpoint: 1000,
										settings: {
											slidesToShow: 1,
										},
									},
								],
							}}
						>
							{this.getReviews(t)}
						</Slider>
					</div>

					<div className="landing-page__mobileApp__wrapper">
						<div className="container">
							<div className="row justify-content-md-center">
								<div className="col-md-9 col-12">
									<div className="landing-page__mobileApp__contentContainer">
										<div className="landing-page__mobileApp__content">
											<div className="landing-page__mobileApp__upperTextContainer">
												<span className="landing-page__mobileApp__upperText">
													{t('LandingPage_MobileApp_UpperText')}
												</span>
											</div>
											<h3 className="landing-page__mobileApp__title">{t('LandingPage_MobileApp_Title')}</h3>
											<p className="landing-page__mobileApp__text">{t('LandingPage_MobileApp_Text')}</p>
										</div>
										<div className="landing-page__mobileApp__imageContainer">
											<img
												src={require(`containers/Html/images/landingpage/mobile_app.png`)}
												className="landing-page__mobileApp__image"
												alt={t('LandingPage_MobileApp_UpperText')}
												loading="lazy"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="landing-page__getInTouch__wrapper">
						<ContactUsForm />
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: IStore) => ({
	shopTypeDomainValues: state.domainValues.shopType,
	officesData: state.offices,
	userprofile: state.userprofile,
	landingpagedata: state.landingPageDataReducer,
});

const mapDispatchToProps = (dispatch) => ({
	getShopTypeDomainValues: () => dispatch(getShopTypeDomainValues()),
	getHomePageStatistics: () => dispatch(getHomePageStatistics()),
});

const LandingPageWithAuth = withAuthContext(LandingPageComponent);
const LandingPageWithRouter = withRouter(LandingPageWithAuth);
const ConnectedLandingPage = connect(mapStateToProps, mapDispatchToProps)(LandingPageWithRouter);
const LandingPage = translate(c.DEFAULT_TRANSLATION_NAMESPACE)(ConnectedLandingPage);

export { LandingPage };
